export const convertConfig: {
  [key: string]: { [key: string]: { [key: string]: string } };
} = {
  nmhExperiment: {
    UAT: {
      existingUserExperimentId: "1004122149",
      existingUserVariationCtrl: "1004289794",
      existingUserVariationNmh: "1004289795",
      newUserExperimentId: "1004118880",
      newUserVariationCtrl: "1004282411",
      newUserVariationNmh: "1004282412",
    },
    Prod: {
      existingUserExperimentId: "1004122585",
      existingUserVariationCtrl: "1004290801",
      existingUserVariationNmh: "1004290802",
      newUserExperimentId: "1004122586",
      newUserVariationCtrl: "1004290803",
      newUserVariationNmh: "1004290804",
    },
  },
  // PaymentFirstCheckout A/B (OMG-1916). Structure mirrors nmhExperiment.
  // The variant arm is served at its own URL (PAYMENT_FIRST_CHECKOUT_PATH); the
  // marketing pricing CTA reads window._paymentFirstEnabled (set by the Convert
  // variation JS on /join/pricing) and routes the variant there — the route's
  // presence is the variant signal (see CheckoutPaymentFirst). IDs are the real
  // Convert account 10042912 / project 10043933 experiences.
  paymentFirstExperiment: {
    UAT: {
      experimentId: "1004204684",
      variationControl: "1004480907",
      variationVariant: "1004480908",
    },
    Prod: {
      experimentId: "1004204681",
      variationControl: "1004480901",
      variationVariant: "1004480902",
    },
  },
};
